/**
 * The three glyphs a personal record can be set on — KANON view 06's feed tiles.
 *
 * A record row's tile is the axis's hue at 18% with the axis's DRAWING on it, and the drawing is
 * what says which kind of record it was without reading the word beside it: a barbell for a heaviest
 * weight, a rising line with a point for a best estimated single, three growing bars for a biggest
 * volume. The canon draws exactly these three shapes — one path, one path plus a dot, three rects —
 * and this file is the transcription.
 *
 * Inline SVG rather than a sprite or a font, and drawn by us rather than taken from an icon set:
 * these are UI glyphs, not brand marks, and `AuthIcons` already sets the house construction — a
 * 24×24 box, `currentColor`, a 2px round stroke, `aria-hidden`. Every one of them sits inside a tile
 * whose row already names the axis in words, so announcing them would say it twice.
 */

interface IconProps {
  className?: string;
}

const STROKE_PROPS = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
} as const;

/** A heaviest weight: a bar with a plate at each end. */
export function BarbellIcon({ className }: IconProps) {
  return (
    <svg className={className} {...STROKE_PROPS}>
      <path d="M4 9v6M8 7v10M16 7v10M20 9v6M8 12h8" />
    </svg>
  );
}

/** A best estimated single: a line rising to a point, which is what an e1RM record is. */
export function TrendIcon({ className }: IconProps) {
  return (
    <svg className={className} {...STROKE_PROPS}>
      <path d="M4 16l5-5 4 3 6-7" />
      <circle cx="19" cy="7" r="1.6" fill="currentColor" stroke="none" />
    </svg>
  );
}

/** A biggest volume: three bars, each taller than the last. */
export function BarsIcon({ className }: IconProps) {
  return (
    <svg className={className} {...STROKE_PROPS}>
      <path d="M6 18v-4M12 18v-8M18 18v-12" />
    </svg>
  );
}
